var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('comfirm-box'),_c('v-overlay',{staticStyle:{"z-index":"99999"},attrs:{"opacity":0.3,"value":_vm.isLoading}},[_c('loading-bar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }